import authAxios from "../config/authAxios"
import { modulosTypes } from "./types"
import Swal from 'sweetalert2';
import { avisoCorrecto, avisoError } from "../view/components/AvisosMensajes/MensajesSwalf";

export const obtenerModulos = () => {
  return async dispatch => {
    dispatch({
      type: modulosTypes.OBTENER_MODULOS
    })
    try {
      const respuesta = await authAxios.get(`/admin/modulos`);
      dispatch({
        type: modulosTypes.OBTENER_MODULOS_EXITO,
        payload: respuesta.data.data
      })
    } catch (error) {
      console.log(error);
      avisoError(error.response.data.msg);
      dispatch({
        type: modulosTypes.OBTENER_MODULOS_ERROR,
        payload: error.response.data.msg
      })
    }
  }
}

export const eliminarModulo = idModulo => {
  return async dispatch => {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-danger"
      },
      buttonsStyling: false
      });
      swalWithBootstrapButtons
      .fire({
          title: "¿Estas seguro?",
          text: "Se eliminara todo registro",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Si, continuar!",
          cancelButtonText: "No, cancelar!",
          reverseButtons: true,
          showLoaderOnConfirm: true,
          preConfirm: async function() {
          //consultando para ver el mensaje de aprovación
          try {
            const respuesta = await authAxios.delete(`/admin/mdlo_eliminarModulo__idModulo/${idModulo}`);
            if (!(respuesta.data.error)) {
              dispatch({
                payload: idModulo,
                type: modulosTypes.ELIMINAR_MODULO_EXITO
              })
            }
            return true;
          } catch (error) {
              console.log(error)
              const msg = error.response !== undefined ? error.response.data.msg : error 
              Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: msg
              })
          }
          },
          allowOutsideClick: () => !Swal.isLoading()
      })
      .then(result => {
          //mensaje que se elimino el archivo correctamente
          if (result.value === true) {
          swalWithBootstrapButtons.fire(
              "Eliminado!",
              "Se elimino el modulo correctamente",
              "success"
          );
          }
      });
  }
}

export const insertarModulo = (datos, onCloseModal) => {
  return async dispatch => {
    dispatch({
      type: modulosTypes.NUEVO_MODULO
    })
    try {
      const respuesta = await authAxios.post(`/admin/modulo`, datos);
      dispatch({
        type: modulosTypes.NUEVO_MODULO_EXITO,
        payload: respuesta.data.data
      })
      avisoCorrecto('Se inserto módulo correctamente');
      if(onCloseModal) onCloseModal();
    } catch (error) {
      console.log(error.response.data.msg);
      dispatch({
        type: modulosTypes.NUEVO_MODULO_ERROR
      })
    }
  }
}

export const editarModulo = (idModulo, datos, onCloseModal) => {
  return async dispatch => {
    dispatch({
      type: modulosTypes.EDITAR_MODULO
    })
    try {
      const respuesta = await authAxios.put(`/admin/modulo/${idModulo}`, datos);
      dispatch({
        type: modulosTypes.EDITAR_MODULO_EXITO,
        payload: {
          idModulo,
          datos: respuesta.data.data
        }
      })
      avisoCorrecto('Se edito correctamente el módulo');
      if(onCloseModal) onCloseModal();
    } catch (error) {
      console.log(error);
      avisoError(error.response.data.msg);
      dispatch({
        type: modulosTypes.EDITAR_MODULO_ERROR,
        payload: error.response.data.msg
      })
    }
  }
}

// ── Publicación Web WooCommerce ───────────────────────────────────────────────

export const obtenerPublicacionWeb = (idModulo) => {
  return async () => {
    try {
      const respuesta = await authAxios.get(`/admin/modulo/${idModulo}/publicacion-web`);
      return {
        pub:    respuesta.data.data   || null,
        modulo: respuesta.data.modulo || null,
      };
    } catch (error) {
      console.log(error);
      return { pub: null, modulo: null };
    }
  };
};

export const guardarPublicacionWeb = (idModulo, datos) => {
  return async () => {
    try {
      const respuesta = await authAxios.post(`/admin/modulo/${idModulo}/publicacion-web`, datos);
      if (respuesta.data.ok) {
        avisoCorrecto('Configuración guardada correctamente');
        return true;
      }
      avisoError('Error al guardar la configuración');
      return false;
    } catch (error) {
      console.log(error);
      avisoError('Error al guardar la configuración');
      return false;
    }
  };
};

export const subirImagenWeb = (idModulo, archivo) => {
  return async () => {
    try {
      const formData = new FormData();
      formData.append('imagen', archivo);
      const respuesta = await authAxios.post(
        `/admin/modulo/${idModulo}/imagen-web`,
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );
      if (respuesta.data.ok) return respuesta.data.url;
      avisoError(respuesta.data.error || 'Error al subir imagen');
      return null;
    } catch (error) {
      avisoError('Error al subir la imagen');
      return null;
    }
  };
};

export const sincronizarWooCommerce = (idModulo) => {
  return async () => {
    try {
      const respuesta = await authAxios.post(`/admin/modulo/${idModulo}/sincronizar-woo`);
      return respuesta.data;
    } catch (error) {
      const data = error.response?.data;
      return { ok: false, error: data?.error || 'Error de conexión', errores: data?.errores || [] };
    }
  };
};
